var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EBEEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 24C11.1778 24 10.7593 23.8259 10.4111 23.4778C10.063 23.1296 9.88889 22.7111 9.88889 22.2222V10.6667H9V8.88889H13.4444V8H18.7778V8.88889H23.2222V10.6667H22.3333V22.2222C22.3333 22.7111 22.1593 23.1296 21.8111 23.4778C21.463 23.8259 21.0444 24 20.5556 24H11.6667ZM20.5556 10.6667H11.6667V22.2222H20.5556V10.6667ZM13.4444 20.4444H15.2222V12.4444H13.4444V20.4444ZM17 20.4444H18.7778V12.4444H17V20.4444Z",
    fill: "#D03C28"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBox);
export default __webpack_public_path__ + "static/media/deleteBox.b1e5de0f7c3b9a700bfdd5047c9bbd8a.svg";
export { ForwardRef as ReactComponent };